import React from 'react';

import { Button, Typography } from '@mui/material';

import citySketch from '@kamernet/assets/CitySketch.webp';
import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { useSearchAlert } from '../../../hooks/useSearchAlertHandling';
import { AlertSnackbar } from '../../Snackbar/Snackbar';

import styles from './SearchAlertBanner.module.css';

export const SearchAlertBanner = () => {
  const { T } = useIntl();
  const {
    onSearchAlertClick,
    searchAlertNotification,
    handleCloseAlertSnackbar,
  } = useSearchAlert();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div>
          <Typography className={CommonStyles.padding_bottom_1} variant="h5">
            {T('search_alerts.search_page.heading.automate_search')}
          </Typography>
          <Typography className={CommonStyles.padding_bottom_1} variant="body2">
            {T('search_alerts.search_page.body.new_place')}
          </Typography>
        </div>

        <Button
          className={styles.button}
          variant="contained"
          size="medium"
          onClick={onSearchAlertClick}
        >
          {T('cta.create_search_alert')}
        </Button>
      </div>
      <div>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img className={styles.media} src={citySketch.src} alt="City sketch" />
      </div>

      {searchAlertNotification && (
        <AlertSnackbar
          notification={searchAlertNotification}
          onClose={handleCloseAlertSnackbar}
        />
      )}
    </div>
  );
};
